import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CONSULT_MODE, CREATE_MODE, NONE_MODE, UPDATE_MODE } from '../mode';
import { ALTERNATIVE_LOADING_STATUS, FAILURE_STATUS, IDLE_STATUS, LOADING_STATUS, SUCCESS_STATUS } from '../status';
import i18n from '../../i18n';
import { save,register,activateById,fetchAll,fetchById,inactivateById } from './masterAPI';

const initialState = {
    status: IDLE_STATUS,
    mode: {
        main: NONE_MODE,
      },
    error: null,
    response: {
      status: null,
      message: null,
      data: null,
    },
    list: [],
    type: null,
    operation: "IMPORTACAO",
    model: {
      id: undefined,
      code: undefined,
      description: undefined,
      numeroMaster:null,
      consignatario:{
        id:null,
      },
      exportador:{
        id:null,
      },
      transportadorInternacional:{
        id:null,
      },
      origem:{
        id:null,
      },
      destino:{
        id:null,
      },
      tipoFrete:null,
      tipoEmbarque:{
        id:null,
      },
      masterCustos:[],
      ignorableFields: {
        referenciaCliente:{
          despesaReceita: {
            id:null,
          },
          moeda:{
            id:null,
          },
          valorComprar:null,
        },
      },
  },
}

const fetchAllAsync = createAsyncThunk('master/fetchAll', async (params) => {
    const { data } = await fetchAll(params);
    return { data };
});

const fetchByIdAsync = createAsyncThunk('master/fetchById', async (data) => {
    const response = await fetchById(data);
    return {
        response: {
            status: response.status,
            data: response.data,
          },
    };
});

const activateByIdAsync = createAsyncThunk('master/activateById', async (id) => {
    const { status, data } = await activateById(id);
    return { response: { status, data } };
});

const inactivateByIdAsync = createAsyncThunk('master/inactivateById',async (id) => {
    const { status, data } = await inactivateById(id);
    return { response: { status, data } };
  }
);

const masterSlice = createSlice({
    name: 'master',
    initialState,
    reducers: {
      changeStatusTo: (state, action) => {
        state.status = action.payload.status;
      },
      loading: (state) => {
        state.status = LOADING_STATUS;
      },
      success: (state) => {
        state.status = SUCCESS_STATUS;
      },
      failure: (state) => {
        state.status = FAILURE_STATUS;
      },
      resetStatus: (state) => {
        state.status = IDLE_STATUS;
      },
      changeModeTo: (state, action) => {
        state.mode.main = action.payload;
      },
      changeToCreateMode: (state) => {
        state.mode.main = CREATE_MODE;
      },
      changeToConsultMode: (state) => {
        state.mode.main = CONSULT_MODE;
      },
      changeToUpdateMode: (state) => {
        state.mode.main = UPDATE_MODE;
      },
      setMasterType: (state) => {
        state.type = "MASTER";
      },
      setOperationImportacao: (state) => {
        state.operation = "IMPORTACAO";
      },
      setOperationExportacao: (state) => {
        state.operation = "EXPORTACAO";
      },
      setBlType: (state) => {
        state.type = "BL";
      },
      resetType: (state) => {
        state.type = null;
      },
      resetMode: (state) => {
        state.mode.main = NONE_MODE;
      },
      setModel: (state, action) => {
        state.model = {
          ...action.payload,
        };
      },
      resetModel: (state) => {
        state.model = initialState.model;
      },
      addToList: (state, action) => {
        state.list = [...state.list, action.payload.data];
      },
      updateOnList: (state, action) => {
        state.list = state.list.map((current) => {
          if (current.id === action.payload.data?.id) {
            return action.payload.data;
          }
          return current;
        });
      },
      resetList: (state) => {
        state.list = [];
      },
      setList: (state, action) => {
        state.list = action.payload.data;
      },
      setResponse: (state, action) => {
        state.response = action.payload;
      },
      clearResponse: (state) => {
        state.response = {
          status: null,
          message: null,
          data: null,
        };
      },
      setError: (state, action) => {
        state.error = action.payload;
      },
      clearError: (state) => {
        state.error = initialState.error;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchAllAsync.pending, (state) => {
          state.status = ALTERNATIVE_LOADING_STATUS;
        })
        .addCase(fetchAllAsync.fulfilled, (state, action) => {
          state.status = IDLE_STATUS;
          state.list = action.payload.data;
        })
        .addCase(fetchAllAsync.rejected, (state, action) => {
          state.status = FAILURE_STATUS;
          state.error = {
            ...action.error,
            message: i18n.t('com.muralis.qcx.erro.erroCarregarListaDespesaReceita', { erro: action.error.message }),
          };
        })
        .addCase(fetchByIdAsync.pending, (state) => {
          state.status = LOADING_STATUS;
        })
        .addCase(fetchByIdAsync.fulfilled, (state, action) => {
          if (action.payload.response.status === 200) {
            state.model = {
              ...action.payload.response.data,
            };
            state.status = SUCCESS_STATUS;
          }
        })
        .addCase(fetchByIdAsync.rejected, (state, action) => {
          state.status = FAILURE_STATUS;
          state.error = {
            ...action.error,
            message: i18n.t('com.muralis.qcx.erro.erroCarregarDespesaReceita', { erro: action.error.message }),
          };
        })
        .addCase(activateByIdAsync.pending, (state) => {
          state.status = LOADING_STATUS;
        })
        .addCase(activateByIdAsync.fulfilled, (state, action) => {
          state.status = SUCCESS_STATUS;
          state.response.status = action.payload.response.status;
          state.response.data = action.payload.response.data;
  
          const { description  } = action.payload.response.data;
  
          state.response.message = i18n.t('com.muralis.qcx.mensagem.despesaReceitaAtivada', {
            receitaDespesa: '',
            description,
          });
  
          if (state.response.status === 200) {
            state.list = state.list.map((current) =>
              current.id === action.payload.response.data.id ? action.payload.response.data : current
            );
          }
        })
        .addCase(activateByIdAsync.rejected, (state, action) => {
          state.status = FAILURE_STATUS;
          state.error = {
            ...action.error,
            message: i18n.t('com.muralis.qcx.erro.erroAtivarDespesaReceita', { erro: action.error.message }),
          };
        })
        .addCase(inactivateByIdAsync.pending, (state) => {
          state.status = LOADING_STATUS;
        })
        .addCase(inactivateByIdAsync.fulfilled, (state, action) => {
          state.status = SUCCESS_STATUS;
          state.response.status = action.payload.response.status;
          state.response.data = action.payload.response.data;
  
          const { description } = action.payload.response.data;

          state.response.message = i18n.t('com.muralis.qcx.mensagem.DespesaReceitaInativada', {
            receitaDespesa: '',
            description,
          });
  
          if (state.response.status === 200) {
            state.list = state.list.map((current) =>
              current.id === action.payload.response.data.id ? action.payload.response.data : current
            );
          }
        })
        .addCase(inactivateByIdAsync.rejected, (state, action) => {
          state.status = FAILURE_STATUS;
          state.error = {
            ...action.error,
            message: i18n.t('com.muralis.qcx.erro.erroInativarDespesaReceita', { erro: action.error.message }),
          };
        });
    },
});

const selectError = (state) => state.master.error;
const selectResponse = (state) => state.master.response;
const selectStatus = (state) => state.master.status;
const selectMode = (state) => state.master.mode.main; 
const selectMaster = (state) => state.master.model;
const selectMasters = (state) => state.master.list;
const selectBackgroundMode = (state) => state.master.mode.background;
const selectSubMode = (state) => state.master.mode.sub;
const selectMasterType = (state) => state.master.type;
const selectOperationMaster = (state) => state.master.operation;

const {
    changeStatusTo,
    loading,
    success,
    failure,
    resetStatus,
    changeModeTo,
    changeToCreateMode,
    changeToConsultMode,
    changeToUpdateMode, 
    resetMode,
    setModel,
    resetModel,
    addToList,
    updateOnList,
    resetList,
    setList,
    setResponse,
    clearResponse,
    setError,
    setMasterType,
    setBlType,
    resetType,
    clearError,
    setOperationExportacao,
    setOperationImportacao,
} = masterSlice.actions;


export {
  changeToCreateMode,
  changeToConsultMode,
  selectError,
  selectResponse,
  selectStatus,
  selectMode,
  clearError,
  clearResponse,
  resetStatus,
  selectMaster,
  changeToUpdateMode,
  selectMasters,
  selectBackgroundMode,
  selectSubMode,
  setModel,
  fetchAllAsync,
  fetchByIdAsync,
  resetModel,
  resetMode,
  setResponse,
  addToList,
  success,
  setError,
  failure,
  loading,
  setMasterType,
  setBlType,
  resetType,
  selectMasterType,
  setOperationExportacao,
  setOperationImportacao,
  selectOperationMaster,
};

export default masterSlice.reducer;